import { createApp } from 'vue';
import '@/assets/styles/main.css';
import App from './App.vue';
import { setupI18n } from '@/i18n';
import { setupRouter } from '@/router';
import TopoRadio from '@/components/TopoRadio.vue';

// Set up internationalization
const i18n = setupI18n();

// Set up router
const router = setupRouter(i18n);

// Create app and register plugins & components
const app = createApp(App)
    .use(i18n)
    .use(router)
    .component('TopoRadio', TopoRadio);

// Mount app
router.isReady().then(() =>
{
    const _app = app.mount('#app');

    if (import.meta.env.MODE !== 'production')
    {
        // Make the app instance globally available in development environment
        window.app = _app;
    }
});
